import { metricsServerApi } from '../../modules/servers/api'
import {
  DemoteAllOffPitchResponseBody,
  HardwareServiceRequestBody,
  PromoteAllOnPitchResponseBody,
  PromoteAllResponseBody,
  SeatSwappingStateResponseBody,
  SleepAllButOnFieldResponseBody,
  UpdateSeatConfigurationRequestBody
} from './types'
import { SessionModeTypeValues } from '../sessions/types'

export const hardwareApi = metricsServerApi.injectEndpoints({
  endpoints: (builder) => ({
    // Generic hardware service
    hardwareService: builder.mutation<void, HardwareServiceRequestBody>({
      query: ({ tagIds, type }) => ({
        url: `service/${type}`,
        method: 'POST',
        body: { ids: tagIds },
        withCredentials: true
      })
    }),

    // Enable RSSI
    enableRSSI: builder.mutation<void, void>({
      query: () => ({
        url: 'service/enableRSSI',
        method: 'POST',
        body: {},
        withCredentials: true
      })
    }),

    // Disable RSSI
    disableRSSI: builder.mutation<void, void>({
      query: () => ({
        url: 'service/disableRSSI',
        method: 'POST',
        body: {},
        withCredentials: true
      })
    }),

    // Sleep all but on field
    sleepAllButOnField: builder.mutation<SleepAllButOnFieldResponseBody, void>({
      query: () => ({
        url: 'service/greylist/offpitch',
        method: 'POST',
        withCredentials: true
      })
    }),

    // Update seat swapping algorithm state
    updateSeatSwappingAlgoState: builder.mutation<
      SeatSwappingStateResponseBody,
      void
    >({
      query: () => ({
        url: 'service/seatSwap',
        method: 'POST',
        withCredentials: true
      })
    }),

    // Reset seat swapping
    resetSeatSwapping: builder.mutation<SeatSwappingStateResponseBody, void>({
      query: () => ({
        url: 'service/seatSwap/reset',
        method: 'POST',
        withCredentials: true
      })
    }),

    // Update seat configuration
    updateSeatConfiguration: builder.mutation<
      any,
      UpdateSeatConfigurationRequestBody
    >({
      query: (data) => ({
        url: 'service/seatConfiguration',
        method: 'POST',
        body: data,
        withCredentials: true
      })
    }),

    // Post config to daemon
    postSeatConfigurationToDaemon: builder.mutation<
      any,
      { sessionMode: SessionModeTypeValues }
    >({
      query: (data) => ({
        url: 'service/precreate',
        method: 'POST',
        body: data,
        withCredentials: true
      })
    }),

    // Demote off pitch
    demoteAllOffPitch: builder.mutation<DemoteAllOffPitchResponseBody, void>({
      query: () => ({
        url: 'service/power/demote/offPitch',
        method: 'POST',
        withCredentials: true
      })
    }),

    // Promote on pitch
    promoteAllOnPitch: builder.mutation<PromoteAllOnPitchResponseBody, void>({
      query: () => ({
        url: 'service/power/promote/onPitch',
        method: 'POST',
        withCredentials: true
      })
    }),

    // Promote all
    promoteAll: builder.mutation<PromoteAllResponseBody, void>({
      query: () => ({
        url: 'service/power/promote/all',
        method: 'POST',
        withCredentials: true
      })
    }),

    // Clear hardware
    clearHardware: builder.mutation<void, void>({
      query: () => ({
        url: 'service/config/clear_diagnostics',
        method: 'GET',
        withCredentials: true
      })
    })
  })
})

export const {
  useHardwareServiceMutation,
  useEnableRSSIMutation,
  useDisableRSSIMutation,
  useSleepAllButOnFieldMutation,
  useUpdateSeatSwappingAlgoStateMutation,
  useResetSeatSwappingMutation,
  useUpdateSeatConfigurationMutation,
  usePostSeatConfigurationToDaemonMutation,
  useDemoteAllOffPitchMutation,
  usePromoteAllOnPitchMutation,
  usePromoteAllMutation,
  useClearHardwareMutation
} = hardwareApi

export const {
  hardwareService,
  enableRSSI,
  disableRSSI,
  sleepAllButOnField,
  updateSeatSwappingAlgoState,
  resetSeatSwapping,
  updateSeatConfiguration,
  postSeatConfigurationToDaemon,
  demoteAllOffPitch,
  promoteAllOnPitch,
  promoteAll,
  clearHardware
} = hardwareApi.endpoints
